// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1767":"428a019a","5814":"e43d1648","7256":"cb79721d","8419":"299c1eec","8709":"cf265052","9058":"299c1eec"}[chunkId] + ".chunk.css";
};